var url = `https://api.hyperobjects.design`

if(window.location.host.includes("localhost")) {
    url = `http://localhost:5000`
}

export var apiUrl = url